import createReducer from '../../createReducer';
import { setPaymentMetadata, setPaymentMethods } from '../actions/CashierActions';

const initialState = {
  paymentsMethods: [],
  paymentsTypes: [],
};

function toInternalPaymentType({ paymentMethod }) {
  if (paymentMethod === 'creditCard') {
    return 'credit';
  } else if (paymentMethod === 'offline') {
    return 'cash';
  } else {
    return paymentMethod;
  }
}

const handlers = {
  [setPaymentMethods]: (state, payload) => {
    const { paymentMethods } = payload;
    const paymentTypes = paymentMethods.map(toInternalPaymentType);

    return {
      ...state,
      paymentMethods,
      paymentTypes,
    };
  },
  [setPaymentMetadata]: (state, payload) => {
    const { paymentMetadata } = payload;

    return {
      ...state,
      paymentMetadata,
    };
  },
};

export default createReducer(initialState, handlers);
